export class NewRegistration {

  name: string;
  birthAt: string;
  federalCode: string;
  email: string;
  phoneMobile: string;
  phoneCommercial: string;
  phoneResidential: string;
  password: string;
  passwordCheck: string;

  constructor() {
    this.name = null;
    this.birthAt = null;
    this.federalCode = null;
    this.email = null;
    this.phoneMobile = null;
    this.phoneCommercial = null;
    this.phoneResidential = null;
    this.password = null;
    this.passwordCheck = null;
  }

}



// WEBPACK FOOTER //
// ./src/models/newregistration.ts